import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for saved user on mount
  useEffect(() => {
    const savedUser = localStorage.getItem('macys-user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setIsLoading(false);
  }, []);

  // Save user to localStorage when it changes
  useEffect(() => {
    if (user) {
      localStorage.setItem('macys-user', JSON.stringify(user));
    } else {
      localStorage.removeItem('macys-user');
    }
  }, [user]);

  const signIn = (email, password) => {
    // Simulate authentication (in real app, this would be an API call)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (email && password.length >= 6) {
          const newUser = {
            id: Date.now().toString(),
            email: email,
            name: email.split('@')[0],
            createdAt: new Date().toISOString(),
          };
          setUser(newUser);
          resolve(newUser);
        } else {
          reject(new Error('Invalid email or password'));
        }
      }, 1000);
    });
  };

  const signUp = (name, email, password) => {
    // Simulate registration (in real app, this would be an API call)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (name && email && password.length >= 6) {
          const newUser = {
            id: Date.now().toString(),
            email: email,
            name: name,
            createdAt: new Date().toISOString(),
          };
          setUser(newUser);
          resolve(newUser);
        } else {
          reject(new Error('Please fill all fields correctly'));
        }
      }, 1000);
    });
  };

  const signOut = () => {
    setUser(null);
    localStorage.removeItem('macys-user');
  };

  const updateProfile = (updates) => {
    setUser((prevUser) => ({
      ...prevUser,
      ...updates,
    }));
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isAuthenticated: !!user,
        signIn,
        signUp,
        signOut,
        updateProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
